import type { BoxProps } from '../box'

import Box from '../box'
import { useStyleConfig, vui } from '../core'
import { cs } from '../utils'
import { useFooterContext } from './context'

/** Organizes Footer content into a row of multuple columns. */
const FooterRow = vui<'div', BoxProps>((props, ref) => {
  const { className, ...rest } = props
  const styles = useStyleConfig('Footer', useFooterContext())

  return (
    <Box
      className={cs('vui-footerRow', className)}
      ref={ref}
      wrap
      {...styles.row}
      gap={{ xs: 2, sm: 0, md: 0 }}
      {...rest}
    />
  )
})

FooterRow.displayName = 'FooterRow'
export default FooterRow
